import React from 'react';
import PopupDetail from '../../components/popup/detail/PopupDetail';
import { withRedirectUnauthorized } from '../../feature/authority/utils/withAuthority';

const PopupDetailPage = () => {
  return <PopupDetail />;
};

export default withRedirectUnauthorized('popup', PopupDetailPage);
